<template>
  <ul class="navigation flex text-white flex-col py-4 px-1">

    <router-link to="/dashboard" class="nav-item" active-class="active">
      <div class="nav-link">
        <i class="fa-solid fa-table-cells-large nav-link-icon"/>
        <p>{{$t('sidebar.dashboard')}}</p>
      </div>
    </router-link>

    <router-link to="/category" class="nav-item" active-class="active" v-if="hasMenuAction('CATEGORY')">
      <div class="nav-link">
        <i class="fa-solid fa-building-user nav-link-icon"/>
        <p>{{$t('sidebar.buildingType')}}</p>
      </div>
    </router-link>

    <router-link to="/product" class="nav-item" active-class="active" v-if="hasMenuAction('PRODUCT')">
      <div class="nav-link">
        <i class="fa-solid fa-building nav-link-icon"/>
        <p>{{$t('sidebar.product')}}</p>
      </div>
    </router-link>

    <!--              <router-link to="/identification" class="nav-item" active-class="active" v-if="hasMenuAction('IDENTIFICATION')">-->
    <router-link to="/identification" class="nav-item" active-class="active">
      <div class="nav-link">
        <i class="fa-solid fa-user-tie nav-link-icon"/>
        <p>{{$t('sidebar.identification')}}</p>
      </div>
    </router-link>

    <router-link to="/region" class="nav-item" active-class="active" v-if="hasMenuAction('REGION')">
      <div class="nav-link">
        <i class="fa-solid fa-location-dot nav-link-icon"/>
        <p>{{$t('sidebar.region')}}</p>
      </div>
    </router-link>

    <router-link to="/message" class="nav-item" active-class="active" v-if="hasMenuAction('MESSAGE')">
      <div class="nav-link">
        <i class="fa-solid fa-message nav-link-icon"/>
        <p>{{$t('sidebar.message')}}</p>
      </div>
    </router-link>

    <router-link to="/settings" class="nav-item" active-class="active" v-if="hasMenuAction('SETTINGS')">
      <div class="nav-link">
        <i class="fa-solid fa-gear nav-link-icon"/>
        <p>{{$t('sidebar.settings')}}</p>
      </div>
    </router-link>

    <router-link tag="li" to="/user" class="nav-item" active-class="active" v-if="hasMenuAction('USER')">
      <a class="nav-link">
        <i class="fa-solid fa-users nav-link-icon"/>
        <p>{{$t('sidebar.users')}}</p>
      </a>
    </router-link>

    <router-link to="/map" class="nav-item" active-class="active" v-if="hasMenuAction('MAP')">
      <div class="nav-link">
        <i class="fa-solid fa-map nav-link-icon"/>
        <p>{{$t('sidebar.map')}}</p>
      </div>
    </router-link>

    <router-link to="/building-type" class="nav-item" active-class="active" v-if="hasMenuAction('BUILDING_TYPE')">
      <div class="nav-link">
        <i class="fa-solid fa-chart-pie nav-link-icon"/>
        <p>{{$t('sidebar.categories')}}</p>
      </div>
    </router-link>

    <router-link to="/sale" class="nav-item" active-class="active" v-if="hasMenuAction('SALE')">
      <div class="nav-link">
        <i class="fa-solid fa-briefcase nav-link-icon"/>
        <p>{{$t('sidebar.sale')}}</p>
      </div>
    </router-link>

    <router-link to="/order" class="nav-item" active-class="active" v-if="hasMenuAction('ORDER')">
      <div class="nav-link">
        <i class="fa-solid fa-paper-plane nav-link-icon"/>
        <p>{{$t('sidebar.order')}}</p>
      </div>
    </router-link>

    <router-link to="/objects-analysis" class="nav-item" active-class="active" v-if="hasMenuAction('OBJECTS_ANALYSIS')">
      <div class="nav-link">
        <i class="fa-solid fa-building-circle-check nav-link-icon md:-mr-2"/>
        <p>{{$t('sidebar.objectsAnalysis')}}</p>
      </div>
    </router-link>

    <router-link to="/buyer-list" class="nav-item" active-class="active" v-if="hasMenuAction('OBJECTS_ANALYSIS')">
      <div class="nav-link">
        <i class="fa-solid fa-users nav-link-icon"/>
        <p>{{$t('buyer.title')}}</p>
      </div>
    </router-link>

    <router-link to="/publish-to-advertisement" class="nav-item" active-class="active" v-if="hasMenuAction('PUBLISH_TO_ADVERTISEMENT')">
      <div class="nav-link">
        <i class="fa-solid fa-rectangle-ad nav-link-icon"/>
        <p>{{$t('publishToAdvertisement.title')}}</p>
      </div>
    </router-link>

    <router-link to="/realtor-assistants" class="nav-item" active-class="active" v-if="hasMenuAction('LIST_OF_REALTORS')">
      <div class="nav-link">
        <i class="fa-solid fa-user-tag nav-link-icon"/>
        <p>Риэлторлар рўйхати</p>
      </div>
    </router-link>

    <router-link to="/users-sign-policy-contracts" class="nav-item" active-class="active" v-if="hasMenuAction('SIGN_USER_POLICY_CONTRACT')">
      <div class="nav-link">
        <i class="fa-solid fa-user-tag nav-link-icon"/>
        <p>Мулк эгасига Риэлторлик хизматлари рўйхати</p>
      </div>
    </router-link>

  </ul>
</template>

<script>

export default {
  name: 'NavList'
}

</script>